<dx-scroll-view [height]="(windowSize.contentHeight ?? 0) - 75">
  <div class="form">
    <div class="dx-fieldset">
      <!-- Id Griglia -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Id
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-text-box [(value)]="gridConf.gridId"></dx-text-box>
        </div>
      </div>
      <!-- Controller Griglia -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Controller
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-text-box [(value)]="gridConf.controller"></dx-text-box>
        </div>
      </div>
      <!-- Altezza Cella -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Altezza riga griglia in pixel (campo vuoto = default)
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-number-box
            [(value)]="gridConf.rowHeight"
            [showSpinButtons]="true"
            [showClearButton]="true"
          ></dx-number-box>
        </div>
      </div>
      <!--Nr righe per pagina -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Righe per pagina
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-number-box
            [(value)]="gridConf.pageSize"
            [showSpinButtons]="true"
            [showClearButton]="true"
          ></dx-number-box>
        </div>
      </div>
      <!-- Tipo scrolling -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Tipo scrolling
        </div>
        <div class="dx-field-value" style="width: 30%">
          <!-- <dx-select-box
          [showClearButton]="true"
          #selectBoxTipoScrolling
          [items]="gridConfScrollingTypes"
          [(value)]="gridConf.scrollingType"
        ></dx-select-box> -->
        Paginazione
      </div>
    </div>
    <!-- Tipo selezione -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Tipo selezione
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-select-box
          [showClearButton]="true"
          #selectBoxTipoScrolling
          [items]="gridConfSelectionTypes"
          [(value)]="gridConf.selectionMode"
        ></dx-select-box>
      </div>
    </div>
    <!-- Stored Procedure -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Utilizza una SP
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch [(value)]="gridConf.useSp"></dx-switch>
      </div>
    </div>
    <!-- Esportazione Excel -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Abilita esportazione dati
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch [(value)]="gridConf.exportEnabled"></dx-switch>
      </div>
      @if (gridConf.exportEnabled) {
        <div class="dx-field-label" appI18n>
          Nome del file generato dall'esportazione
        </div>
      }
      @if (gridConf.exportEnabled) {
        <div class="dx-field-value">
          <dx-text-box [(value)]="gridConf.exportFileName"></dx-text-box>
        </div>
      }
    </div>
    <!-- Cache sui dati -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Utilizza cache dati
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch [(value)]="gridConf.useCache"></dx-switch>
      </div>
    </div>
    <!-- Cache KEY -->
    @if (gridConf.useCache) {
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Chiave di cache (se diversa da Id)
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-text-box [(value)]="gridConf.cacheKey"></dx-text-box>
        </div>
      </div>
    }
    <!-- Column Chooser -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Abilita il selettore delle colonne
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.actionColumnChooserEnabled"
        ></dx-switch>
      </div>
    </div>
    <!-- Riga dei filtri -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Abilita la riga dei filtri
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch [(value)]="gridConf.filterRowEnabled"></dx-switch>
      </div>
    </div>
    <!-- Pannello di ricerca -->
    <!-- <div class="dx-field">
    <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
      Abilita la ricerca
    </div>
    <div class="dx-field-value" style="width: 30%">
      <dx-switch [(value)]="gridConf.actionSearchPanelEnabled"></dx-switch>
    </div>
  </div> -->
  <!-- Ricerca solo su colonne visibili -->
  <!-- <div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Ricerca solo su colonne visibili
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-switch [(value)]="gridConf.searchVisibleColumnsOnly"></dx-switch>
  </div>
</div> -->
<!-- Pannello di ragruppamento -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Abilita il pannello di ragruppamento
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-switch [(value)]="gridConf.groupPanelEnabled"></dx-switch>
  </div>
</div>
<!-- Salva stato della griglia -->
<!-- <div class="dx-field">
<div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
  Salva stato della griglia (filtri, colonne, etc,etc)
</div>
<div class="dx-field-value" style="width: 30%">
  <dx-switch [(value)]="gridConf.stateSessionEnabled"></dx-switch>
</div>
</div> -->
<!-- Report Name -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Nome Report
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-text-box [(value)]="gridConf.reportName"></dx-text-box>
  </div>
</div>
<!-- Report Params -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    parametri Report
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-text-box [(value)]="gridConf.reportParams"></dx-text-box>
  </div>
</div>
<!-- Report Params -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Visibilità report
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-text-box
      [(value)]="gridConf.reportVisibilityCondition"
    ></dx-text-box>
  </div>
</div>
<!-- Abilita ricerca -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Abilita ricerca testata
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-switch [(value)]="gridConf.actionSearchPanelEnabled"></dx-switch>
  </div>
</div>
<!-- ASPETTA FILTRO -->
<div class="dx-field">
  <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
    Attendi filtro
  </div>
  <div class="dx-field-value" style="width: 30%">
    <dx-switch [(value)]="gridConf.waitForFilter"></dx-switch>
  </div>
</div>
</div>
</div>
</dx-scroll-view>
